// import React, { useEffect, useMemo, useState } from "react";
// import { Link } from "react-router-dom";
// import { useAuth } from "../App";
// import Layout from "../components/Layout";
// import { Card, CardContent } from "../components/ui/card";
// import { Button } from "../components/ui/button";
// import { CalendarDays, MapPin, PlusCircle, Users, Euro } from "lucide-react";
// import { toast } from "sonner";

// const statusLabels = {
//   nouvelle: "Nouvelle",
//   a_analyser: "À analyser",
//   acceptee: "Acceptée",
//   soignant_a_attribuer: "Soignant à attribuer",
//   soignant_attribue: "Soignant attribué",
//   effectuee: "Effectuée",
//   cloturee: "Clôturée",
//   refusee: "Refusée",
// };

// function formatDate(value) {
//   if (!value) return "—";
//   const date = new Date(`${value}T12:00:00`);
//   return Number.isNaN(date.getTime())
//     ? "—"
//     : date.toLocaleDateString("fr-BE");
// }

// function selectedPeriods(creneaux = {}) {
//   return ["matin", "midi", "soir"]
//     .filter((key) => creneaux?.[key]?.selected)
//     .map((key) => key.charAt(0).toUpperCase() + key.slice(1));
// }

// export default function MesRemplacements() {
//   const { axiosInstance } = useAuth();
//   const [items, setItems] = useState([]);
//   const [statusFilter, setStatusFilter] = useState("");
//   const [loading, setLoading] = useState(true);

//   const fetchItems = async () => {
//     try {
//       const res = await axiosInstance.get("/remplacements-domicile/me");
//       setItems(Array.isArray(res.data) ? res.data : []);
//     } catch (err) {
//       toast.error(
//         err.response?.data?.detail ||
//         "Impossible de charger les demandes."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchItems();
//   }, []);

//   const filtered = useMemo(() => {
//     return items
//       .filter((item) => !statusFilter || item.statut === statusFilter)
//       .sort((a, b) => new Date(b.date) - new Date(a.date));
//   }, [items, statusFilter]);

//   return (
//     <Layout title="Mes demandes de remplacement">
//       <div className="space-y-6">
//         <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
//           <div>
//             <h2 className="text-2xl font-semibold text-[#315f63]">
//               Historique des demandes
//             </h2>
//             <p className="mt-1 text-sm text-[#4f7d80]">
//               Consultez le statut, le nombre de patients et le soignant attribué.
//             </p>
//           </div>

//           <Link to="/remplacements-domicile/nouveau">
//             <Button className="bg-[#6faeb2] hover:bg-[#5b979b] text-white">
//               <PlusCircle size={18} className="mr-2" />
//               Nouvelle demande
//             </Button>
//           </Link>
//         </div>

//         <Card className="border-[#d4ebeb] bg-[#f4fafa]">
//           <CardContent className="p-4">
//             <label className="text-sm font-medium text-[#315f63]">
//               Filtrer par statut
//             </label>

//             <select
//               value={statusFilter}
//               onChange={(e) => setStatusFilter(e.target.value)}
//               className="mt-2 w-full rounded-md border border-[#d4ebeb] bg-white px-3 py-2 md:w-80"
//             >
//               <option value="">Tous les statuts</option>
//               {Object.entries(statusLabels).map(([value, label]) => (
//                 <option key={value} value={value}>
//                   {label}
//                 </option>
//               ))}
//             </select>
//           </CardContent>
//         </Card>

//         {loading ? (
//           <p className="text-[#4f7d80]">Chargement…</p>
//         ) : filtered.length === 0 ? (
//           <Card className="border-[#d4ebeb]">
//             <CardContent className="p-8 text-center text-[#4f7d80]">
//               Aucune demande trouvée.
//             </CardContent>
//           </Card>
//         ) : (
//           <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
//             {filtered.map((item) => {
//               const periods = selectedPeriods(item.creneaux);

//               return (
//                 <Card key={item._id} className="border-[#d4ebeb] bg-white">
//                   <CardContent className="p-5 space-y-4">
//                     <div className="flex items-start justify-between gap-4">
//                       <div>
//                         <div className="flex items-center gap-2 text-lg font-bold text-[#315f63]">
//                           <CalendarDays size={18} />
//                           {formatDate(item.date)}
//                         </div>

//                         <div className="mt-2 flex items-center gap-2 text-sm text-[#4f7d80]">
//                           <MapPin size={15} />
//                           {item.zone || "—"}
//                         </div>
//                       </div>

//                       <span className="rounded-full bg-[#e6f3f3] px-3 py-1 text-xs font-semibold text-[#315f63]">
//                         {statusLabels[item.statut] || item.statut}
//                       </span>
//                     </div>

//                     <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
//                       <div className="rounded-lg bg-[#f4fafa] p-3">
//                         <p className="text-xs text-gray-500">Périodes</p>
//                         <p className="font-semibold text-[#315f63]">
//                           {periods.length ? periods.join(" + ") : "—"}
//                         </p>
//                       </div>

//                       <div className="rounded-lg bg-[#f4fafa] p-3">
//                         <p className="text-xs text-gray-500">Patients</p>
//                         <p className="font-semibold text-[#315f63]">
//                           {item.nombre_patients || 0}
//                         </p>
//                       </div>

//                       <div className="rounded-lg bg-[#f4fafa] p-3">
//                         <p className="text-xs text-gray-500">Estimation</p>
//                         <p className="font-semibold text-[#315f63]">
//                           {Number(item.montant_mutuelle_estime || 0).toFixed(2)} €
//                         </p>
//                       </div>
//                     </div>

//                     {item.soignant_name && (
//                       <div className="rounded-lg border border-green-200 bg-green-50 p-3">
//                         <div className="flex items-center gap-2 text-green-800">
//                           <Users size={16} />
//                           <span>
//                             Soignant attribué : <strong>{item.soignant_name}</strong>
//                           </span>
//                         </div>
//                       </div>
//                     )}
//                   </CardContent>
//                 </Card>
//               );
//             })}
//           </div>
//         )}
//       </div>
//     </Layout>
//   );
// }



import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../App";
import Layout from "../components/Layout";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { CalendarDays, MapPin, PlusCircle, Users, Euro } from "lucide-react";
import { toast } from "sonner";

const statusLabels = {
  nouvelle: "Nouvelle",
  a_analyser: "À analyser",
  acceptee: "Acceptée",
  soignant_a_attribuer: "Soignant à attribuer",
  soignant_attribue: "Soignant attribué",
  effectuee: "Effectuée",
  cloturee: "Clôturée",
  refusee: "Refusée",
};

function formatDate(value) {
  if (!value) return "—";
  const date = new Date(`${value}T12:00:00`);
  return Number.isNaN(date.getTime())
    ? "—"
    : date.toLocaleDateString("fr-BE");
}

function selectedPeriods(creneaux = {}) {
  return ["matin", "midi", "soir"]
    .filter((key) => creneaux?.[key]?.selected)
    .map((key) => key.charAt(0).toUpperCase() + key.slice(1));
}

export default function MesRemplacements() {
  const { axiosInstance } = useAuth();
  const [items, setItems] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchItems = async () => {
    try {
      const res = await axiosInstance.get("/remplacements-domicile/me");
      setItems(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      toast.error(
        err.response?.data?.detail ||
        "Impossible de charger les demandes."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const filtered = useMemo(() => {
    return items
      .filter((item) => !statusFilter || item.statut === statusFilter)
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  }, [items, statusFilter]);

  return (
    <Layout title="Mes demandes de remplacement">
      <div className="space-y-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div>
            <h2 className="text-2xl font-semibold text-[#315f63]">
              Historique des demandes
            </h2>
            <p className="mt-1 text-sm text-[#4f7d80]">
              Consultez le statut, le nombre de patients et le soignant attribué.
            </p>
          </div>

          <Link to="/remplacements-domicile/nouveau">
            <Button className="bg-[#6faeb2] hover:bg-[#5b979b] text-white">
              <PlusCircle size={18} className="mr-2" />
              Nouvelle demande
            </Button>
          </Link>
        </div>

        <Card className="border-[#d4ebeb] bg-[#f4fafa]">
          <CardContent className="p-4">
            <label className="text-sm font-medium text-[#315f63]">
              Filtrer par statut
            </label>

            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="mt-2 w-full rounded-md border border-[#d4ebeb] bg-white px-3 py-2 md:w-80"
            >
              <option value="">Tous les statuts</option>
              {Object.entries(statusLabels).map(([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </CardContent>
        </Card>

        {loading ? (
          <p className="text-[#4f7d80]">Chargement…</p>
        ) : filtered.length === 0 ? (
          <Card className="border-[#d4ebeb]">
            <CardContent className="p-8 text-center text-[#4f7d80]">
              Aucune demande trouvée.
            </CardContent>
          </Card>
        ) : (
          <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
            {filtered.map((item) => {
              const periods = selectedPeriods(item.creneaux);

              return (
                <Card key={item._id} className="border-[#d4ebeb] bg-white">
                  <CardContent className="p-5 space-y-4">
                    <div className="flex items-start justify-between gap-4">
                      <div>
                        <div className="flex items-center gap-2 text-lg font-bold text-[#315f63]">
                          <CalendarDays size={18} />
                          {formatDate(item.date)}
                        </div>

                        <div className="mt-2 flex items-center gap-2 text-sm text-[#4f7d80]">
                          <MapPin size={15} />
                          {item.zone || "—"}
                        </div>
                      </div>

                      <span className="rounded-full bg-[#e6f3f3] px-3 py-1 text-xs font-semibold text-[#315f63]">
                        {statusLabels[item.statut] || item.statut}
                      </span>
                    </div>

                    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
                      <div className="rounded-lg bg-[#f4fafa] p-3">
                        <p className="text-xs text-gray-500">Périodes</p>
                        <p className="font-semibold text-[#315f63]">
                          {periods.length ? periods.join(" + ") : "—"}
                        </p>
                      </div>

                      <div className="rounded-lg bg-[#f4fafa] p-3">
                        <p className="text-xs text-gray-500">Patients</p>
                        <p className="font-semibold text-[#315f63]">
                          {item.nombre_patients || 0}
                        </p>
                      </div>

                      <div className="rounded-lg bg-[#f4fafa] p-3">
                        <p className="text-xs text-gray-500">Estimation</p>
                        <p className="font-semibold text-[#315f63]">
                          {Number(item.montant_mutuelle_estime || 0).toFixed(2)} €
                        </p>
                      </div>
                    </div>

                    {item.soignant_name && (
                      <div className="rounded-lg border border-green-200 bg-green-50 p-3">
                        <div className="flex items-center gap-2 text-green-800">
                          <Users size={16} />
                          <span>
                            Soignant attribué : <strong>{item.soignant_name}</strong>
                          </span>
                        </div>
                      </div>
                    )}
                  </CardContent>
                </Card>
              );
            })}
          </div>
        )}
      </div>
    </Layout>
  );
}
